import React from "react";
import styled from "styled-components";

export default function PlatformSectionHeader({title, description, count, unit = "건", action = null, collapsible = false, open = false, onToggle}) {
  return (
      <Header as={collapsible ? "button" : "header"} type={collapsible ? "button" : undefined} onClick={collapsible ? onToggle : undefined} $collapsible={collapsible} $open={open} aria-expanded={collapsible ? open : undefined}>
        <TitleArea>
          <Accent/>
          <div>
            <TitleLine>
              <Title>{title}</Title>
              {count !== undefined && count !== null && <Count><strong>{count}</strong><span>{unit}</span></Count>}
            </TitleLine>
            <Description>{description}</Description>
          </div>
        </TitleArea>
        <RightArea>
          {(!collapsible || !open) && action}
          {collapsible && <DropdownIcon $open={open} aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="m7 10 5 5 5-5H7Z"/></svg></DropdownIcon>}
        </RightArea>
      </Header>
  );
}

const Header = styled.header`
  display:flex; min-height:${({$collapsible}) => $collapsible ? "66px" : "74px"}; box-sizing:border-box; align-items:center;
  justify-content:space-between; gap:18px; padding:16px 20px;
  padding:${({$collapsible}) => $collapsible ? "14px 18px" : "16px 20px"};
  border:0;border-bottom:1px solid ${({$collapsible, $open}) => $collapsible ? ($open ? "#f1e4da" : "transparent") : "#eeeeee"};background:${({$collapsible}) => $collapsible ? "#fff" : "#f9fafb"};
  font-family:inherit;
  width:100%; color:inherit; text-align:left;
  cursor:${({$collapsible}) => $collapsible ? "pointer" : "default"};
  &:hover{background:${({$collapsible}) => $collapsible ? "#fffaf6" : "#f9fafb"};}
  &:focus-visible{outline:1px solid #f5811f;outline-offset:-1px;}
  @media(max-width:700px){align-items:flex-start;flex-direction:column;gap:12px;}
`;
const TitleArea = styled.div`display:flex;min-width:0;align-items:center;gap:11px;`;
const Accent = styled.span`width:4px;height:34px;flex:0 0 4px;border-radius:2px;background:#f5811f;`;
const TitleLine = styled.div`display:flex;align-items:center;gap:8px;margin-bottom:4px;`;
const Title = styled.div`color:#222;font-size:var(--font-size-17);font-weight:700;`;
const Description = styled.div`color:#888;font-size:var(--font-size-12);line-height:1.5;`;
const RightArea = styled.div`display:flex;min-width:0;flex:0 0 auto;align-items:center;justify-content:flex-end;gap:9px;`;
const Count = styled.div`
  display:inline-flex;min-height:25px;align-items:center;gap:4px;padding:0 9px;
  border:1px solid #f1d4c2;border-radius:13px;background:#fff4e8;
  span{color:#888;font-size:var(--font-size-11);} strong{color:#f5811f;font-size:var(--font-size-13);}
`;
const DropdownIcon = styled.span`
  display:inline-flex;flex:0 0 auto;align-items:center;justify-content:center;color:#f5811f;
  transform:rotate(${({$open}) => $open ? "180deg" : "0deg"});transition:transform .18s ease;
`;
